(function() {
  const rowSelector = 'main section > .row';
  const mediaColumnSelector = ':scope > .col-desktop-small-7';
  const summaryColumnSelector = ':scope > .col-desktop-small-5';
  const overflowTolerance = 8;
  const stackedCollapseExtraHeight = 72;

  const summaries = [];

  function isSideBySide(mediaColumn, summaryColumn) {
    const mediaRect = mediaColumn.getBoundingClientRect();
    const summaryRect = summaryColumn.getBoundingClientRect();

    return Math.abs(mediaRect.top - summaryRect.top) < 2 && summaryRect.left > mediaRect.left;
  }

  function setButtonLabel(button, isExpanded) {
    button.textContent = isExpanded ? 'Show Less' : 'Show More';
    button.setAttribute('aria-expanded', String(isExpanded));
  }

  function getCollapseReferenceHeight(mediaColumn) {
    const rect = mediaColumn.getBoundingClientRect();

    return Math.round(rect.height);
  }

  function getStackedCollapseReferenceHeight(content) {
    const contentRect = content.getBoundingClientRect();
    const firstListItem = content.querySelector('li');

    if (firstListItem) {
      const firstListItemRect = firstListItem.getBoundingClientRect();

      return Math.ceil(firstListItemRect.bottom - contentRect.top + stackedCollapseExtraHeight);
    }

    const firstChild = content.firstElementChild;

    if (firstChild) {
      const firstChildRect = firstChild.getBoundingClientRect();

      return Math.ceil(firstChildRect.bottom - contentRect.top + stackedCollapseExtraHeight);
    }

    return stackedCollapseExtraHeight;
  }

  function updateSummaryPaddingProperties(summaryColumn) {
    const style = window.getComputedStyle(summaryColumn);
    const paddingBottom = parseFloat(style.paddingBottom) || 0;

    summaryColumn.style.setProperty('--games-summary-padding-left', style.paddingLeft);
    summaryColumn.style.setProperty('--games-summary-padding-right', style.paddingRight);
    summaryColumn.style.setProperty('--games-summary-padding-bottom', style.paddingBottom);

    return paddingBottom;
  }

  function refreshSummary(summary) {
    const { mediaColumn, summaryColumn, content, button } = summary;
    const mediaHeight = getCollapseReferenceHeight(mediaColumn);
    const isStacked = !isSideBySide(mediaColumn, summaryColumn);
    const isExpanded = summaryColumn.classList.contains('games-summary--expanded');

    const summaryPaddingBottom = updateSummaryPaddingProperties(summaryColumn);
    const referenceHeight = isStacked ? getStackedCollapseReferenceHeight(content) : mediaHeight;
    const collapsedHeight = Math.max(0, referenceHeight - summaryPaddingBottom);

    summaryColumn.classList.remove('games-summary--collapsed', 'games-summary--expandable');
    summaryColumn.style.height = '';
    button.hidden = true;

    if (!(referenceHeight > 0)) {
      setButtonLabel(button, isExpanded);
      return;
    }

    const contentHeight = content.scrollHeight;
    const needsCollapse = contentHeight > collapsedHeight + overflowTolerance;

    if (!needsCollapse) {
      summaryColumn.classList.remove('games-summary--expanded');
      setButtonLabel(button, false);
      return;
    }

    summaryColumn.classList.add('games-summary--expandable');
    button.hidden = false;

    if (isExpanded) {
      setButtonLabel(button, true);
      return;
    }

    summaryColumn.classList.add('games-summary--collapsed');
    summaryColumn.style.height = `${collapsedHeight}px`;
    setButtonLabel(button, false);
  }

  function refreshSummaries() {
    summaries.forEach(refreshSummary);
  }

  function setupSummary(row) {
    const mediaColumn = row.querySelector(mediaColumnSelector);
    const summaryColumn = row.querySelector(summaryColumnSelector);

    if (!mediaColumn || !summaryColumn || summaryColumn.classList.contains('games-summary')) {
      return;
    }

    const content = document.createElement('div');
    content.className = 'games-summary__content';

    while (summaryColumn.firstChild) {
      content.appendChild(summaryColumn.firstChild);
    }

    const button = document.createElement('button');
    button.className = 'button button--small games-summary__toggle';
    button.type = 'button';
    setButtonLabel(button, false);

    button.addEventListener('click', () => {
      summaryColumn.classList.toggle('games-summary--expanded');
      refreshSummary(summary);
    });

    summaryColumn.classList.add('games-summary');
    summaryColumn.appendChild(content);
    summaryColumn.appendChild(button);

    const summary = { mediaColumn, summaryColumn, content, button };
    summaries.push(summary);
  }

  document.querySelectorAll(rowSelector).forEach(setupSummary);

  window.addEventListener('resize', refreshSummaries);
  window.addEventListener('load', refreshSummaries);
  refreshSummaries();
})();
